/**
 * Core configuration and environment types
 */

export interface ChipiSDKConfig {
  apiPublicKey: string;
  environment?: "development" | "production";
  nodeUrl?: string;
  apiSecretKey?: string;
}

export interface ChipiServerSDKConfig extends ChipiSDKConfig {
  apiSecretKey: string;
}

export interface ChipiBrowserSDKConfig extends Omit<ChipiSDKConfig, 'apiSecretKey'> {
  apiSecretKey?: never;
}

export type Environment = "development" | "production";

export type Chain = "STARKNET";

export type ChainToken = "USDC" | "USDT" | "ETH" | "STRK" | "DAI" | "WBTC" | "OTHER";

export interface PaginationQuery {
  page?: number;
  limit?: number;
  offset?: number;
}

export interface PaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const STARKNET_CONTRACTS: Record<ChainToken, { contractAddress: string; decimals: number }> = {
  USDC: {
    contractAddress:
      "0x053c91253bc9682c04929ca02ed00b3e423f6710d2ee7e0d5ebb06f3ecf368a8",
    decimals: 6,
  },
  USDT: {
    contractAddress:
      "0x068f5c6a61780768455de69077e07e89787839bf8166decfbf92b645209c0fb8",
    decimals: 6,
  },
  DAI: {
    contractAddress:
      "0x05574eb6b8789a91466f902c380d978e472db68170ff82a5b650b95a58ddf4ad",
    decimals: 18,
  },
  STRK: {
    contractAddress:
      "0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d",
    decimals: 18,
  },
  ETH: {
    contractAddress:
      "0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7",
    decimals: 18,
  },
  WBTC: {
    contractAddress:
      "0x03fe2b97c1fd336e750087d68b9b867997fd64a2661ff3ca5a7c771641e8e7ac",
    decimals: 8,
  },
  OTHER: {
    contractAddress: "",
    decimals: 18,
  },
};

